import React, { useState } from 'react';
import { ReactComponent as ExportPdf } from '../../../assets/images/PDFIcon.svg';
import { Button } from '../../../components/Button/Button';
import { Tooltip } from 'antd';
import { IconButton } from '../../../components/IconButton/IconButton';
import { ReactComponent as Ellipse } from '../../../assets/images/Ellipse.svg';
import styled, { useTheme } from 'styled-components';
import { PricingLaunchButton } from '../CompetitiveAllowance/PricingLaunchButton';

const HeaderButton = styled(Button)`
	font-size: 14px;
	padding: 0 16px 0 16px;
	height: 32px;
	border-width: 2px;
`;

/** The top section of a product plan */
export function ProductPlanHeaderRow(props: {
	growerName: string;
	growerZip: string;
	growerState: string;

	onSave: () => void;
	/** Disable button if this has value. Value will be shown as tooltip message. */
	disableSave?: string;
	onConvert: () => void;
	disableConvert?: string;
	onPdfDownload: () => void;
	disablePdfDownload?: string;
	/** Omit to hide the Pricing button (no permission). */
	onPricing?: () => void;
	disablePricing?: string;
})
{
	const theme = useTheme();

	return(
		<div className='ProductPlanHeaderRow' style={{
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'flex-start',
			fontFamily: theme.fonts.heading,
			fontSize: theme.fontSizes.large,
			fontWeight: theme.fontWeights.bold,
			paddingLeft: 18,
			paddingRight: 0,
			paddingTop: 16,
			paddingBottom: 1
		}}>
			<div className='PageTitle' style={{fontSize: theme.fontSizes.small}}>
				Acre Proposal
			</div>
			<div style={{ marginRight: 8, marginLeft: 8, marginBottom: 5 }}>
				<Ellipse width={7} height={7} />
			</div>
			<div style={{display: 'flex', flexDirection: 'row', fontSize: theme.fontSizes.large}}>
				<div style={{ marginRight: 8 }}>{props.growerName}</div>
				<div style={{ marginRight: 8 }}>|</div>
				<div style={{ marginRight: 32 }}>{props.growerZip}, {props.growerState}</div>
			</div>
			<div className='Spacer' style={{ flexGrow: 1 }} />			
			<div className='ActionArea' style={{
				flexShrink: 0,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center'
			}}>

				<div style={{display: 'flex', flexDirection: 'row'}}>
					{props.onPricing &&
						<PricingLaunchButton
							className='AcreProposal_OpenPricing'
							onClick={props.onPricing}
							disabledReason={props.disablePricing}
							style={{ marginRight: 12 }}
						/>}
					<IconButton
						tooltip={props.disablePdfDownload ?? ''}
						placement='bottom'
						onClick={props.onPdfDownload}
						fillcolor='auto' // purposefully incorrect so as to not have a fillcolor
						style={{height: 32, width: 32, marginRight: 12}}
						disabled={!!props.disablePdfDownload}
						showDisabledTooltip= { true }
					>
						<ExportPdf height={40} width={40} style={{ position: 'relative' }} />
					</IconButton>
					<Tooltip title={props.disableConvert ?? ''} placement='bottom'>
						<span>
							<HeaderButton 
								variant='outlined' 
								disabled={!!props.disableConvert} 
								onClick={props.onConvert}
							>
							Place on Fields
							</HeaderButton>
						</span>
					</Tooltip>
					<Tooltip title={props.disableSave ?? ''} placement='bottom'>
						<span>
							<HeaderButton 
								style={{ marginLeft: 16 }} 
								variant='dark'
								disabled={!!props.disableSave} 
								onClick={props.onSave}
							>
							Save Proposal
							</HeaderButton>
						</span>
					</Tooltip>
				</div>
			</div>
		</div>
	);
}
